import React, { type JSX } from "react";
import IconContained from "./IconContained";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SensorDoorOutlinedIcon from "@mui/icons-material/SensorDoorOutlined";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { getCategoryIcon } from "../patient/categorize/CategorizeUtils";
import {
  LabelOutlined,
  LockOpenOutlined,
  LockOutlined,
  PeopleOutlined,
  PhotoAlbumOutlined,
} from "@mui/icons-material";

export function CategorizationIcon({
  type,
  attributeType,
}: {
  type: string;
  attributeType: PatientAttributeType;
}): JSX.Element {
  return <IconContained type={type} icon={getCategoryIcon(attributeType)} />;
}

export function PatientIncludedIcon() {
  return <IconContained icon={<ThumbUpAltOutlinedIcon />} />;
}
export function PatientExcludedIcon() {
  return <IconContained icon={<BlockOutlinedIcon />} />;
}
export function PatientUndeterminedIcon() {
  return <IconContained icon={<PersonOutlineOutlinedIcon />} />;
}
export function AdditionalInformationIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<InfoOutlinedIcon />} />;
}
export function VisitRelationship({ type }: { type: string }) {
  return <IconContained type={type} icon={<SensorDoorOutlinedIcon />} />;
}
export function ProjectDetailsIcon({ type }: { type: string }) {
  return (
    <IconContained type={type} icon={<SettingsApplicationsOutlinedIcon />} />
  );
}
export function ProjectFiltersIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<FilterAltOutlinedIcon />} />;
}
export function ProjectLockIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<LockOutlined />} />;
}
export function ProjectUnlockIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<LockOpenOutlined />} />;
}
export function ProjectKeywordsIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<LabelOutlined />} />;
}
export function PatientDicomIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<PhotoAlbumOutlined />} />;
}
export function CohortUpdateIcon({ type }: { type: string }) {
  return <IconContained type={type} icon={<PeopleOutlined />} />;
}
